/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 6V18M12 6H8.66667C8.23242 6 8.0153 6 7.83915 6.05554C7.46576 6.17327 7.17327 6.46576 7.05554 6.83915C7 7.0153 7 7.23242 7 7.66667V7.66667V8M12 6H15.3333C15.7676 6 15.9847 6 16.1608 6.05554C16.5342 6.17327 16.8267 6.46576 16.9445 6.83915C17 7.0153 17 7.23242 17 7.66667V7.66667V8M12 18H15M12 18H9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M12 6V18M12 6H8.6C8.03995 6 7.75992 6 7.54601 6.10899C7.35785 6.20487 7.20487 6.35785 7.10899 6.54601C7 6.75992 7 7.03995 7 7.6V7.66667V8M12 6H15.4C15.9601 6 16.2401 6 16.454 6.10899C16.6422 6.20487 16.7951 6.35785 16.891 6.54601C17 6.75992 17 7.03995 17 7.6V7.66667V8M12 18H15M12 18H9M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM8.66668 5.25L8.58158 5.2499C8.23488 5.24929 7.90396 5.24871 7.61363 5.34025C7.00686 5.53157 6.53158 6.00685 6.34026 6.61362C6.24872 6.90395 6.2493 7.23487 6.24991 7.58157L6.25001 7.66667V8C6.25001 8.41421 6.5858 8.75 7.00001 8.75C7.41422 8.75 7.75001 8.41421 7.75001 8V7.66667C7.75001 7.17575 7.75876 7.10299 7.77084 7.06468C7.81499 6.92466 7.92467 6.81498 8.06469 6.77083C8.103 6.75875 8.17576 6.75 8.66668 6.75H11.25V17.25H9.00001C8.5858 17.25 8.25001 17.5858 8.25001 18C8.25001 18.4142 8.5858 18.75 9.00001 18.75H12H15C15.4142 18.75 15.75 18.4142 15.75 18C15.75 17.5858 15.4142 17.25 15 17.25H12.75V6.75H15.3333C15.8243 6.75 15.897 6.75875 15.9353 6.77083C16.0754 6.81498 16.185 6.92466 16.2292 7.06468C16.2413 7.10299 16.25 7.17575 16.25 7.66667V8C16.25 8.41421 16.5858 8.75 17 8.75C17.4142 8.75 17.75 8.41421 17.75 8V7.66667L17.7501 7.58157C17.7507 7.23487 17.7513 6.90395 17.6598 6.61362C17.4684 6.00685 16.9932 5.53157 16.3864 5.34025C16.0961 5.24871 15.7651 5.24929 15.4184 5.2499L15.3333 5.25H12H8.66668Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M12 6V18M12 6H8.6C8.03995 6 7.75992 6 7.54601 6.10899C7.35785 6.20487 7.20487 6.35785 7.10899 6.54601C7 6.75992 7 7.03995 7 7.6V7.66667V8M12 6H15.4C15.9601 6 16.2401 6 16.454 6.10899C16.6422 6.20487 16.7951 6.35785 16.891 6.54601C17 6.75992 17 7.03995 17 7.6V7.66667V8M12 18H15M12 18H9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 6V18M12 6H8.6C8.03995 6 7.75992 6 7.54601 6.10899C7.35785 6.20487 7.20487 6.35785 7.10899 6.54601C7 6.75992 7 7.03995 7 7.6V7.66667V8M12 6H15.4C15.9601 6 16.2401 6 16.454 6.10899C16.6422 6.20487 16.7951 6.35785 16.891 6.54601C17 6.75992 17 7.03995 17 7.6V7.66667V8M12 18H15M12 18H9M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.58177 5.24985C8.61003 5.2499 8.6384 5.24995 8.66687 5.24995H12.0002H15.3335C15.362 5.24995 15.3904 5.2499 15.4186 5.24985C15.7653 5.24925 16.0962 5.24867 16.3866 5.34021C16.9933 5.53152 17.4686 6.00681 17.6599 6.61358C17.7515 6.9039 17.7509 7.23482 17.7503 7.58152C17.7502 7.60979 17.7502 7.63816 17.7502 7.66662V7.99995C17.7502 8.41417 17.4144 8.74995 17.0002 8.74995C16.586 8.74995 16.2502 8.41417 16.2502 7.99995V7.66662C16.2502 7.1757 16.2414 7.10294 16.2294 7.06464C16.1852 6.92461 16.0755 6.81493 15.9355 6.77078C15.8972 6.7587 15.8245 6.74995 15.3335 6.74995H12.7502V17.25H15.0002C15.4144 17.25 15.7502 17.5857 15.7502 18C15.7502 18.4142 15.4144 18.75 15.0002 18.75H12.0002H9.0002C8.58598 18.75 8.2502 18.4142 8.2502 18C8.2502 17.5857 8.58598 17.25 9.0002 17.25H11.2502V6.74995H8.66687C8.17594 6.74995 8.10318 6.7587 8.06488 6.77078C7.92486 6.81493 7.81517 6.92461 7.77102 7.06464C7.75895 7.10294 7.7502 7.1757 7.7502 7.66662V7.99995C7.7502 8.41417 7.41441 8.74995 7.0002 8.74995C6.58598 8.74995 6.2502 8.41417 6.2502 7.99995V7.66662C6.2502 7.63816 6.25015 7.60979 6.2501 7.58152C6.24949 7.23482 6.24891 6.9039 6.34045 6.61358C6.53176 6.00681 7.00705 5.53152 7.61382 5.34021C7.90415 5.24867 8.23507 5.24925 8.58177 5.24985Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
